var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"snippet"},[(_vm.result.moreAtStart)?_c('span',[_vm._v("...")]):_vm._e(),_c('span',{ref:"elem"},[_vm._t("default")],2),(_vm.result.moreAtEnd)?_c('span',[_vm._v("...")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }